import { createFileRoute, Outlet } from '@tanstack/react-router';

import { TeamMembersProvider } from '@/features/crm/context/TeamMembersContext';
import { DashboardLayout } from '@/features/dashboard';
import { requireRoles } from '@/lib/router/route-guards';

export const Route = createFileRoute('/_protected/dashboard')({
  beforeLoad: ({ context }) => {
    requireRoles(context, ['admin', 'agent'], '/');
  },
  component: DashboardLayoutRoute,
});

function DashboardLayoutRoute() {
  return (
    <TeamMembersProvider>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </TeamMembersProvider>
  );
}
